import * as yup from "yup"

export const basicValidationSchema = yup.object({
    name: yup.string().trim().required("Full name is required"),
    orgname: yup.string().trim().required("Business name is required"),
    email: yup
        .string()
        .trim()
        .email("Invalid email address")
        .max(100, "Email address exceeds 100 characters")
        .required("Business email is required"),
    workphone: yup.string().trim().max(30, "Phone number exceeds 30 characters"),
})

export const fullValidationSchema = basicValidationSchema.concat(
    yup.object().shape({
        count: yup.string().equals(["1", "2-5", "6-15", "16-50", "51+"], "Enter an option from the dropdown"),
    })
)
